module.exports = __webpack_public_path__ + "images/tagger-b22445657245409b1b830950a47d980d.png";